import React, { useState, useCallback } from 'react';
import Hero from '../components/Hero/Hero';
import Values from '../components/Values/Values';
import TechServices from '../components/TechServices/TechServices';
import HowWeWork from '../components/HowWeWork/HowWeWork';
import Results from '../components/Results/Results';
import Testimonials from '../components/Testimonials/Testimonials';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';
import SectionDivider from '../components/SectionDivider/SectionDivider';
import ProjectFormModal from '../components/ProjectFormModal/ProjectFormModal';

const ServicesPage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const scrollToSection = useCallback((sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <>
      <Hero onNavigate={scrollToSection} />
      <SectionDivider variant="blue-to-cream" />
      <main>
        <Values onNavigate={scrollToSection} />
        <SectionDivider variant="cream-to-blue" />
        <TechServices />
        <SectionDivider variant="blue-to-cream" />
        <HowWeWork />
        <SectionDivider variant="cream-to-blue" />
        <Results />
        <SectionDivider variant="blue-to-cream" />
        <Testimonials />
        <SectionDivider variant="cream-to-blue" />
        <Contact onOpenForm={() => setIsFormOpen(true)} />
      </main>
      <SectionDivider variant="blue-to-dark" />
      <Footer />
      <ProjectFormModal isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </>
  );
};

export default ServicesPage;
